import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { POLICY_DOC_SCAN_STATUS } from '../constants/policy-doc';

@supertypeClass({ toClient: true, toServer: true })
export class PolicyDocQuery extends Everything {
  @property()
  type: string;

  @property({
    values: {
      uploaded: 'Uploaded Document',
      algo: 'Generated by Algo Underwriting',
      app: 'Application Package',
    },
  })
  docSource: string;

  @property({
    values: {
      App: 'Application',
      AppSupplement: 'AdditionalDetails',
      Aviation: 'AviationSupp',
      Avocation: 'AvocationSupp',
      ForeignTravel: 'TravelForm',
      Bene: 'BeneDesgination',
      Owner: 'OwnerDesignation',
      ACBRDisclosure: 'ACBRDisclosure',
      StateDisclosure: 'StateDisclosure',
      MiscSupp: 'MiscSupp',
      Packet: 'AppPacket',
      HIPPA: 'HIPPA',
      visa: 'Visa/Green card',
      i797: 'I-797',
      archive: 'Archive',
      Insurability: 'Insurability',
      Amendment: 'Amendment',
      FR2217: 'FR2217',
      FR2200: 'FR2200',
      CIRDisclosure: 'CIRDisclosure',
      FR3010: 'FR3010',
    },
  })
  appType: string;

  @property()
  subType: string;

  @property()
  name: string;

  @property()
  date: Date;

  @property()
  docType: string;

  /**
   * For use with admin policy_summary doc tabs in updating doc types
   */
  @property({ persist: false })
  newDocType: string;

  @property()
  uploadedBy: string;

  @property()
  status: string;

  @property()
  isActive: boolean;

  get virusScanStatus(): string {
    return this.status ? this.status : POLICY_DOC_SCAN_STATUS.NOT_APPLICABLE;
  }

  constructor() {
    super();
  }

  static new() {
    return new PolicyDocQuery().init();
  }

  init() {
    return this;
  }
}
